import { categories } from '@/mocks/hoobuyData';

export default function CategoryGrid() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3.5 py-1.5 rounded-full border border-background-300 text-xs font-medium text-foreground-600 mb-4">
            Todas as Categorias
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Encontre Seu Estilo Favorito
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            Navegue por 14 categorias cuidadosamente organizadas com os melhores fornecedores do Hoobuy Spreadsheet
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.link}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200 hover:border-primary-300 overflow-hidden transition-all cursor-pointer"
            >
              <div className="relative w-full h-28 md:h-32 overflow-hidden bg-background-100">
                <img
                  src={cat.image}
                  alt={cat.namePt}
                  loading="lazy"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
              </div>
              <div className="flex flex-col items-center gap-1 p-3 md:p-4">
                <span className="text-xs md:text-sm font-semibold text-foreground-800 text-center leading-tight whitespace-nowrap">
                  {cat.namePt}
                </span>
                <span className="text-[10px] md:text-xs text-foreground-400 text-center leading-snug hidden sm:block">
                  {cat.description}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}